import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AscService } from '@draeger-academy/common/lib/services/acs-input/acs.service';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { CoursesService } from '@draeger-academy/common/lib/services/courses/courses.services';
import { PortalConfigurationService } from '@draeger-academy/common/lib/services/portal-configuration/portal-configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { Course } from '../../../../../models/course';
import { FilteringComponent } from '../filtering/filtering.component';
import { SelectComponent } from '../select/select.component';
import { ShowMoreComponent } from '../show-more/show-more.component';

@Component({
    selector: 'da-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit, OnDestroy {
    @ViewChild('showMoreSection') showMoreSection: ShowMoreComponent;
    @Input() portal: string = null;
    public categoryName = '';
    public active = false;
    public coursesPerPage = 10;
    public isPartnerPage = false;
    public hasFocus = false;
    public sortingSelectedValue = null;
    public numberOfCourses = 0;
    public hasFocusTitle = false;
    public title = '';
    public isPresence = true;
    public isOnline = true;
    public show = false;
    public coursesByTitle: Course[];
    public month = 0;
    public year = 0;
    public city = '';
    public sortValue = '';
    public hasFocusYear = false;
    public hasFocusMonth = false;
    public hasFocusCity = false;
    public expand = false;
    public linkToTrainingAdvisor: string;
    public showTextToTrainingAdvisor = false;
    public courses: Course[];
    public site: string;
    public label: string;
    public isUserPage = false;
    public countryCode: string;
    private innerScreenWidth: number;
    private _$categories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$sortOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseFilterMonths: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseFilterYears: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseTypeFilterOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$showServerError: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showCart: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$loading: BehaviorSubject<boolean> = new BehaviorSubject(true);
    private _$courses: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$selectedValue: BehaviorSubject<string> = new BehaviorSubject('0');
    private _$coursesFiltered: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$coursesFilteredMore: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$courseFilterCities: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
    private _$serverError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showSecondLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private _$hideFirstLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showThirdLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private _$showMoreInformation: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _subscriptionSiteSettings: Subscription;
    private _subscriptionQueryParams: Subscription;
    private _subscriptionCourses: Subscription;
    private _$translations: BehaviorSubject<any> = new BehaviorSubject({});
    @ViewChild(FilteringComponent) filters: FilteringComponent;
    @ViewChild(SelectComponent) select: SelectComponent;

    constructor(
        private activatedRoute: ActivatedRoute,
        private _coursesService: CoursesService,
        private _portalConfigurationService: PortalConfigurationService,
        private _configurationService: ConfigurationService,
        private _translateService: TranslateService,
        private asc: AscService
    ) {
        _translateService.get('routes.training-advisor').subscribe((res: string) => {
            if (res && res !== 'routes.training-advisor') {
                this.showTextToTrainingAdvisor = true;
            }
        });
    }

    public get showServerError$(): Observable<boolean> {
        return this._$showServerError.asObservable();
    }

    public get loading$(): Observable<boolean> {
        return this._$loading.asObservable();
    }

    public get showSecondLevelFiltering$(): Observable<boolean> {
        return this._$showSecondLevelFiltering.asObservable();
    }

    public get hideFirstLevelFiltering$(): Observable<boolean> {
        return this._$hideFirstLevelFiltering.asObservable();
    }

    public get showThirdLevelFiltering$(): Observable<boolean> {
        return this._$showThirdLevelFiltering.asObservable();
    }

    public get serverError$(): Observable<{}> {
        return this._$serverError.asObservable();
    }

    public get showFilter$(): Observable<boolean> {
        return of(this._$coursesFiltered.getValue()?.length > 0 && this._$categories.getValue() !== null);
    }

    public get coursesFiltered$(): Observable<Course[]> {
        return this._$coursesFiltered.asObservable();
    }

    public get coursesFilteredMore$(): Observable<Course[]> {
        return this._$coursesFilteredMore.asObservable();
    }

    public get showMoreInformation$(): Observable<boolean> {
        return this._$showMoreInformation.asObservable();
    }

    public get showFiltering$(): Observable<boolean> {
        return this._$showFiltering.asObservable();
    }

    public get categories$(): Observable<any> {
        return this._$categories.asObservable();
    }

    public get sortOptions$(): Observable<any> {
        return this._$sortOptions.asObservable();
    }

    public get courseTypeFilterOptions$(): Observable<any> {
        return this._$courseTypeFilterOptions.asObservable();
    }

    public get courseFilterCities$(): Observable<any> {
        return this._$courseFilterCities.asObservable();
    }

    public get courseFilterMonths$(): Observable<any> {
        return this._$courseFilterMonths.asObservable();
    }

    public get courseFilterYears$(): Observable<any> {
        return this._$courseFilterYears.asObservable();
    }
    public closeError() {
        this._$showServerError.next(false);
    }

    ngOnDestroy() {
        if (this._subscriptionSiteSettings) {
            this._subscriptionSiteSettings.unsubscribe();
        }
        if (this._subscriptionQueryParams) {
            this._subscriptionQueryParams.unsubscribe();
        }
        if (this._subscriptionCourses) {
            this._subscriptionCourses.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.innerScreenWidth = window.innerWidth;

        this.initGetCoureses();

        this._$showCart.next(this._configurationService.hasFeature('ShoppingCart'));

        this.showFiltering();

        this._$showSecondLevelFiltering.next(
            this._configurationService.hasFeature('SecondLevelFiltering') || this._configurationService.isPartnerPage()
        );
        this._$showThirdLevelFiltering.next(
            this._configurationService.hasFeature('ThirdLevelFiltering') || this._configurationService.isPartnerPage()
        );

        this.setSortingOptions();
        this.setMonthsOptions();

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
            this.site = site;
        }
        const _site = isPortal ? currentPortal : site;

        this.title = sessionStorage.getItem(`titleFilteringValue${_site}`);

        this.title = sessionStorage.getItem(`titleFilteringValue${_site}`);

        if (localStorage.getItem(`showMoreCourses${_site}`) === 'true') {
            this.showMore(true);
            this.expand = true;
        }

        this._translateService.get('routes.training-advisor'.toLowerCase()).subscribe((data) => {
            if (data) {
                this._$translations.next(data);
                this.linkToTrainingAdvisor = `/${_site}/${data}`;
            }
        });
        this._coursesService.languageSelected.subscribe((language) => {
            this.initGetCoureses();
        });
    }

    initGetCoureses() {
        this.isPartnerPage = this._configurationService.isPartnerPage();

        let prom1: Promise<any>;
        if (this.portal) {
            prom1 = this._getPortalCourses(this.portal);
        } else {
            prom1 = this.getCourses();
        }

        const prom2 = new Promise((resolve) => {
            if (this.isPartnerPage) {
                this._portalConfigurationService.loadPortalPreferences(this.portal).then((preferences) => {
                    const defaultCountry = preferences.defaultCountry.toLocaleLowerCase();
                    const defaultLanguage = preferences.defaultLanguage.toLocaleLowerCase();
                    this.countryCode = defaultLanguage + '_' + defaultCountry;
                    this._coursesService.getCategories(this.portal, this.countryCode).then((categories) => {
                        return resolve(categories);
                    });
                });
            } else {
                return this._coursesService.getCategories(this.portal, this.countryCode).then((categories) => {
                    return resolve(categories);
                });
            }
        });
        Promise.all([prom1, prom2]).then((proms) => {
            this._parseCourses(proms[0]);
            this.checkIfCoursesHaveBusinessField(proms[1]);
            this._$loading.next(false);
            this._translateService.stream('common'.toLowerCase()).subscribe((data) => {
                this._$translations.next(data);
                this.label = this._$translations.getValue().filteringDropdownAll
                    ? this._$translations.getValue().filteringDropdownAll
                    : 'All';
                if (this._$translations.getValue().filteringDropdownAll) {
                    this.checkIfCoursesHaveBusinessField(proms[1]);
                }
            });
        });
    }

    public showFiltering() {
        const isPortal = this._configurationService.isPartnerPage();

        if (!isPortal) {
            this._$showFiltering.next(this._configurationService.hasFeature('SearchBy'));
        } else {
            this._configurationService.getConfigPartnerByPortal().then((values) => {
                if (values) {
                    const tempFeatures = values.filter((setting) => setting.key.toLowerCase() === 'features');
                    let hasCheckPrerequest;
                    if (tempFeatures && tempFeatures[0] && tempFeatures[0].value && tempFeatures[0].value.length > 0) {
                        hasCheckPrerequest = tempFeatures[0].value.filter((setting) => setting.name === 'SearchBy');
                    }
                    if (hasCheckPrerequest && hasCheckPrerequest[0] && hasCheckPrerequest[0].enabled) {
                        this._$showFiltering.next(true);
                    }
                }
            });
        }
    }

    public setMonthsOptions() {
        const isPortal = this._configurationService.isPartnerPage();

        if (!isPortal) {
            const _monthsOptions = this._configurationService.MonthsOptions;
            if (_monthsOptions && _monthsOptions[0]) {
                const _monthOptionsValues = _monthsOptions[0].value;
                this._$courseFilterMonths.next(_monthOptionsValues);
            }
        } else {
            this._configurationService.getConfigPartnerByPortal().then((values) => {
                if (values) {
                    const tempSortOption = values.filter((setting) => setting.key.toLowerCase() === 'months');
                    if (tempSortOption && tempSortOption[0] && tempSortOption[0].value) {
                        const _sortOptionsValues = tempSortOption[0].value;
                        this._$courseFilterMonths.next(_sortOptionsValues);
                    }
                }
            });
        }
    }
    public setSortingOptions() {
        const isPortal = this._configurationService.isPartnerPage();

        if (!isPortal) {
            const _sortOptions = this._configurationService.SortOptions;
            if (_sortOptions && _sortOptions[0]) {
                const _sortOptionsValues = _sortOptions[0].value;
                this.sortValue = _sortOptions[0].value;
                this._$sortOptions.next(_sortOptionsValues);
            }
        } else {
            this._translateService.stream('common').subscribe((translation) => {
                const tempSortOption = translation.sortOptions;
                if (tempSortOption) {
                    const _sortOptionsValues = tempSortOption;
                    this.sortValue = tempSortOption[0];
                    this._$sortOptions.next(_sortOptionsValues);
                }
            });
        }
    }

    public compareNumbers(a, b) {
        return b - a;
    }

    public changeView(active, $event: Event) {
        $event.preventDefault();
        if (!active) {
            this.active = !this.active;
        }

        this.innerScreenWidth = window.innerWidth;

        if (this.portal) {
            this._getPortalCourses(this.portal);
        } else {
            this.getCourses();
        }
    }

    public onSelect(categoryId) {
        if (categoryId === null || !categoryId) {
            categoryId = '0';
        }
        if (this._$categories.getValue()) {
            this._$categories.getValue().filter((data) => {
                if (
                    (data && data.id && data.id.toString() === categoryId) ||
                    (data && data.id === 0 && data.id.toString() === categoryId)
                ) {
                    this.categoryName = data.name;
                }
            });
        }
        this.filterCourses();
    }

    public onSelectSubCat(value) {
        this.filterCourses();
    }

    public onSelectSubSubCat(categoryId) {
        this.filterCourses();
    }

    public showMore($event: boolean) {
        this._$showMoreInformation.next($event);

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
        }
        const _site = isPortal ? currentPortal : site;
        localStorage.setItem(`showMoreCourses${_site}`, $event.toString());

        // f (this.showMoreSection) this.showMoreSection._$showMore.next($event);

        this.innerScreenWidth = window.innerWidth;

        if (this.portal) {
            this._getPortalCourses(this.portal);
        } else {
            this.getCourses();
        }

        if (this.expand) {
            localStorage.setItem(`showMoreCourses${_site}`, 'false');
        }
        this.expand = !this.expand;
    }

    public filterCourses() {
        let filteredMore = [];
        let coursesFiltered = [];
        const _labelNoValue = this._$translations.getValue().filteringDropdownNoSelection
            ? this._$translations.getValue().filteringDropdownNoSelection
            : 'No selected value';
        let _site;
        if (this._configurationService.getSiteFromUrl()) {
            _site = this._configurationService.getSiteFromUrl().site;
        }
        const currentPortal = this._configurationService.portalId;

        const isPortal = this._configurationService.isPartnerPage();
        const lang =
            JSON.parse(sessionStorage.getItem('portalLang')) && JSON.parse(sessionStorage.getItem('portalLang')).lang
                ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                : '';
        const seletedValue = isPortal
            ? sessionStorage.getItem(`selectedValue${currentPortal}${lang}`)
            : sessionStorage.getItem(`selectedValue${_site}`);
        const selectedValueSubCat = isPortal
            ? sessionStorage.getItem(`selectedSubCatValue${currentPortal}${lang}`)
            : sessionStorage.getItem(`selectedSubCatValue${_site}`);
        const selectedValueSubSubCat = isPortal
            ? sessionStorage.getItem(`selectedSubSubCatValue${currentPortal}${lang}`)
            : sessionStorage.getItem(`selectedSubSubCatValue${_site}`);

        if (seletedValue === '0' || seletedValue === 'null' || seletedValue === null || seletedValue === this.label) {
            if (isPortal) {
                const language = JSON.parse(sessionStorage.getItem('portalLang')).lang
                    ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                    : '';
                this._$selectedValue.next('0');
                sessionStorage.setItem(`selectedValue${currentPortal}${language}`, '0');
            } else {
                this._$selectedValue.next('0');
                sessionStorage.setItem(`selectedValue${_site}`, '0');
            }

            if (this._configurationService.$coursesPerPage) {
                this._subscriptionCourses = this._configurationService.$coursesPerPage.subscribe((data) => {
                    if (data) {
                        this.coursesPerPage = Number(data);
                    }
                });
            }
            if (this._$courses.getValue() && this._$courses.getValue().length > 0) {
                let courses = this._$courses.getValue();

                courses = this.sortCourses(this._$courses.getValue());
                if (this._configurationService.CourseTypeFilterOptions && this._configurationService.CourseTypeFilterOptions.length > 0) {
                    courses = this.filterByType(courses);
                }

                if (this._configurationService.hasFeature('SearchBy')) {
                    courses = this.filterByTitle(courses);
                }

                if (this._configurationService.MonthsOptions && this._configurationService.MonthsOptions.length > 0) {
                    courses = this.filterByMonth(courses);
                }
                if (this._configurationService.YearsOptions && this._configurationService.YearsOptions.length > 0) {
                    courses = this.filterByYear(courses);
                }

                courses = this.filterByCity(courses);

                this.numberOfCourses = courses.length;
                filteredMore = courses.slice(this.coursesPerPage, this._$courses.getValue().length);
                this.coursesByTitle = courses;
                coursesFiltered = courses.slice(0, this.coursesPerPage);
                this._$coursesFilteredMore.next(filteredMore);
                this._$coursesFiltered.next(coursesFiltered);
            }
        } else {
            if (
                this._$courses.getValue() &&
                seletedValue !== '0' &&
                (!selectedValueSubCat ||
                    selectedValueSubCat === this.label ||
                    selectedValueSubCat === 'null' ||
                    selectedValueSubCat === null ||
                    selectedValueSubCat === _labelNoValue) &&
                (!selectedValueSubSubCat ||
                    selectedValueSubSubCat === this.label ||
                    selectedValueSubSubCat === 'null' ||
                    selectedValueSubSubCat === null ||
                    selectedValueSubSubCat === _labelNoValue)
            ) {
                this._$courses.getValue().filter((course) => {
                    if (course.categoryId === seletedValue || course.categoryName === seletedValue) {
                        filteredMore = [];
                        coursesFiltered.push(course);
                    }
                });
            }

            if (
                this._$courses.getValue() &&
                seletedValue &&
                selectedValueSubCat &&
                (!selectedValueSubSubCat || selectedValueSubSubCat === this.label || selectedValueSubSubCat === _labelNoValue)
            ) {
                this._$courses.getValue().filter((course) => {
                    const upperCaseNames = course.trainingSegments.map((value) => {
                        return value.toUpperCase();
                    });
                    if (
                        (course.categoryId === seletedValue || course.categoryName === seletedValue) &&
                        upperCaseNames.indexOf(selectedValueSubCat.toUpperCase()) > -1
                    ) {
                        coursesFiltered.push(course);
                    }
                });
            }

            if (
                this._$courses.getValue() &&
                seletedValue &&
                selectedValueSubCat &&
                selectedValueSubSubCat &&
                selectedValueSubCat !== this.label &&
                selectedValueSubSubCat !== this.label
            ) {
                this._$courses.getValue().filter((course) => {
                    const upperCaseTrainigSegments = course.trainingSegments.map((value) => {
                        return value.toUpperCase();
                    });

                    const upperCaseProductAreas = course.productAreas.map((value) => {
                        return value.toUpperCase();
                    });

                    if (
                        (course.categoryId === seletedValue || course.categoryName === seletedValue) &&
                        upperCaseTrainigSegments.indexOf(selectedValueSubCat.toUpperCase()) > -1 &&
                        upperCaseProductAreas.indexOf(selectedValueSubSubCat.toUpperCase()) > -1
                    ) {
                        coursesFiltered.push(course);
                    }
                });
            }

            let courses = coursesFiltered;
            courses = this.sortCourses(courses);
            if (this._configurationService.CourseTypeFilterOptions && this._configurationService.CourseTypeFilterOptions.length > 0) {
                courses = this.filterByType(courses);
            }

            if (this._configurationService.hasFeature('SearchBy')) {
                courses = this.filterByTitle(courses);
            }

            if (this._configurationService.MonthsOptions && this._configurationService.MonthsOptions.length > 0) {
                courses = this.filterByMonth(courses);
            }
            if (this._configurationService.YearsOptions && this._configurationService.YearsOptions.length > 0) {
                courses = this.filterByYear(courses);
            }
            courses = this.filterByCity(courses);
            this.numberOfCourses = courses.length;
            this.coursesByTitle = courses;
            coursesFiltered = courses.slice(0, this.coursesPerPage);
            filteredMore = courses.slice(this.coursesPerPage, courses.length);
            this._$coursesFilteredMore.next(filteredMore);
            this._$coursesFiltered.next(coursesFiltered);
        }

        if (
            sessionStorage.getItem(`cityTypeFiltering${_site}`) &&
            sessionStorage.getItem(`cityTypeFiltering${_site}`) !== '' &&
            sessionStorage.getItem(`cityTypeFiltering${_site}`) !== null
        ) {
            this.city = sessionStorage.getItem(`cityTypeFiltering${_site}`);
        } else {
            this.city = this.label;
        }
    }

    public getCourses(): Promise<any> {
        return this._coursesService.getAllCourses().then(
            (courses) => {
                this.courses = courses;
                return courses;
            },
            (error) => {
                console.log(error);
                this._$serverError.next(true);
            }
        );
    }

    private _getPortalCourses(portal: string): Promise<any> {
        const _portal = this._portalConfigurationService.getPortalIdWithUnderscore(portal);
        return this._coursesService.getAllPortalCourses(_portal).then(
            (courses) => {
                this.courses = courses;
                return courses;
            },
            (error) => {
                console.log(error);
                this._$serverError.next(true);
            }
        );
    }

    private _parseCourses(courses) {
        if (courses.status && courses.status === 404) {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
        } else if (courses.status && courses.status === 500) {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
            this._$showServerError.next(true);
        } else if (courses && courses.length > 0) {
            this._$courses.next(courses);

            const _availableCities = [];
            const _availableYears = [];

            this._translateService.stream('common'.toLowerCase()).subscribe((data) => {
                this._$translations.next(data);
                this.label = this._$translations.getValue().filteringDropdownAll
                    ? this._$translations.getValue().filteringDropdownAll
                    : 'All';
            });
            _availableCities.push({ key: this.label, value: this.label });
            _availableYears.push({ key: 0, value: this.label });
            const tempYears = [];
            if (courses && this.sortCourses.length > 0) {
                courses.forEach((course) => {
                    course.events.forEach((event) => {
                        if (event.location && !_availableCities.some((item) => item.value === event.location.city)) {
                            _availableCities.push({ key: event.location.city, value: event.location.city });
                        }
                        const newDate = new Date(event.beginDateTime);
                        const year = newDate.getFullYear();

                        if (year && !tempYears.some((item) => item.value === year)) {
                            tempYears.push({ key: year, value: year });
                        }
                    });
                });
            }

            tempYears.sort((a, b) => (a.key > b.key ? 1 : b.key > a.key ? -1 : 0));

            tempYears.forEach((item) => {
                _availableYears.push(item);
            });

            _availableYears.push({
                key: _availableYears[_availableYears.length - 1].key + 1,
                value: _availableYears[_availableYears.length - 1].key + 1
            });
            _availableCities.sort((a, b) => a.value.localeCompare(b.value));

            this._$courseFilterCities.next(_availableCities);
            this._$courseFilterYears.next(_availableYears);

            const isPortal = this._configurationService.isPartnerPage();
            const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

            if (sessionStorage.getItem(`cityTypeFiltering${_site}`) && sessionStorage.getItem(`cityTypeFiltering${_site}`) !== null) {
                this.city = sessionStorage.getItem(`cityTypeFiltering${_site}`);
            } else {
                this.city = this.label;
            }

            this._subscriptionQueryParams = this.activatedRoute.queryParams.subscribe((params) => {
                const _catFromParameters = params['cat'];
                if (_catFromParameters) {
                    this._coursesService.getCategories(this.portal, this.countryCode).then((categories) => {
                        if (categories) {
                            categories.filter((data) => {
                                if (data.name.toLowerCase().replaceAll(' ', '') === _catFromParameters.toLowerCase()) {
                                    this.onSelect(data.id);
                                    this._$selectedValue.next(data.id);
                                    let _siteFromUrl;
                                    if (this._configurationService.getSiteFromUrl()) {
                                        _siteFromUrl = this._configurationService.getSiteFromUrl().site;
                                    }
                                    const currentPortal = this._configurationService.portalId;
                                    const isItPortal = this._configurationService.isPartnerPage();
                                    if (isItPortal) {
                                        const lang = JSON.parse(sessionStorage.getItem('portalLang')).lang
                                            ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                                            : '';
                                        sessionStorage.setItem(`selectedValue${currentPortal}${lang}`, data.id);
                                        sessionStorage.removeItem(`selectedSubCatValue${currentPortal}${lang}`);
                                        sessionStorage.removeItem(`selectedSubSubCatValue${currentPortal}${lang}`);
                                    } else {
                                        sessionStorage.setItem(`selectedValue${_siteFromUrl}`, data.id);
                                        sessionStorage.removeItem(`selectedSubCatValue${_siteFromUrl}`);
                                        sessionStorage.removeItem(`selectedSubSubCatValue${_siteFromUrl}`);
                                    }
                                }
                            });
                        }
                    });
                }
                this.filterCourses();
            });
        } else {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
        }
    }

    dynamicSort(property, sortReverse) {
        let sortOrder = -1;

        if (sortReverse) {
            sortOrder = 1;
        }

        return (a, b) => {
            const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
            return result * sortOrder;
        };
    }

    public sortCourses(coursesList) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        let selectedValueKey = sessionStorage.getItem(`selectedSortingValue${_site}`);
        let selectedValue;
        this.sortValue = selectedValueKey;

        if (!selectedValueKey || selectedValueKey === null || selectedValueKey === undefined) {
            if (this._configurationService.SortOptions && this._configurationService.SortOptions[0]) {
                selectedValueKey = this._configurationService.SortOptions[0].value[0].key;
                this.sortValue = this._configurationService.SortOptions[0].value[0].key;
                selectedValue = this._configurationService.SortOptions[0].value[0].value;
            }
        }

        if (!this._configurationService.hasFeature('SortBy')) {
            selectedValueKey = 'name';
        }

        switch (selectedValueKey) {
            case 'name': {
                return coursesList.sort((a, b) => a.name.localeCompare(b.name));
            }
            case 'bestseller': {
                const _label = this._$translations.getValue().all ? this._$translations.getValue().bestseller : 'bestseller';
                return this.sortByLabel(coursesList, 'bestseller', _label);
            }
            case 'new': {
                const _label = this._$translations.getValue().all ? this._$translations.getValue().new : 'new';
                return this.sortByLabel(coursesList, 'new', _label);
            }
            case null: {
                const _label = this._$translations.getValue().all ? this._$translations.getValue().bestseller : 'bestseller';
                return this.sortByLabel(coursesList, 'bestseller', _label);
            }
            default: {
                const _label = this._$translations.getValue().all ? this._$translations.getValue().bestseller : 'bestseller';
                return this.sortByLabel(coursesList, 'bestseller', _label);
            }
        }
    }

    private sortByLabel(coursesList, label, _label) {
        let withLabel = [];
        let withoutLabel = [];
        let wordValue = 'name';
        let wordValues = [];

        if (this._configurationService.SortOptions && this._configurationService.SortOptions[0]) {
            wordValues = this._configurationService.SortOptions[0].value;
            wordValues.forEach((element) => {
                if (element.key === label) {
                    wordValue = element.key;
                }
            });
        }

        coursesList.forEach((element) => {
            if (element.keyWords && element.keyWords[0] && element.keyWords[0].toLowerCase().indexOf(_label) > -1) {
                withLabel.push(element);
            } else {
                withoutLabel.push(element);
            }
        });

        withLabel = withLabel.sort((a, b) => a.name.localeCompare(b.name));
        withoutLabel = withoutLabel.sort((a, b) => a.name.localeCompare(b.name));
        withLabel = withLabel.concat(withoutLabel);

        return withLabel;
    }

    public filterByType(coursesList) {
        const isPortal = this._configurationService.isPartnerPage();
        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getSiteFromUrl().site;
        const isPresence = sessionStorage.getItem(`courseTypeIsOnline${_site}`);
        const isOnline = sessionStorage.getItem(`courseTypeIsPresence${_site}`);

        let filteredCourses = [];

        if (this.isPresence && this.isOnline) {
            filteredCourses = coursesList;
        } else if (this.isPresence) {
            coursesList.filter((course) => {
                if (course.isProduct === false) {
                    filteredCourses.push(course);
                }
            });
        } else if (this.isOnline) {
            coursesList.filter((course) => {
                if (course.isProduct === true) {
                    filteredCourses.push(course);
                }
            });
        }
        return filteredCourses;
    }
    public filterByYear(courses) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();
        const selectedValue = sessionStorage.getItem(`yearTypeFiltering${_site}`);
        const selectedValueMonth = sessionStorage.getItem(`monthFiltering${_site}`);

        const coursesByTitle = [];

        if (
            selectedValue !== null &&
            selectedValue !== '0' &&
            !(selectedValue === '') &&
            selectedValue !== 'undefined' &&
            selectedValue !== this.label
        ) {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    const newDate = new Date(event.beginDateTime);
                    const year = newDate.getFullYear();
                    const month = Number(newDate.getMonth()) + 1;

                    if (year.toString() === selectedValue && !coursesByTitle.includes(course)) {
                        if (
                            selectedValueMonth !== null &&
                            selectedValueMonth !== '' &&
                            selectedValueMonth !== 'undefined' &&
                            selectedValueMonth !== this.label &&
                            selectedValueMonth !== '0'
                        ) {
                            if (month.toString() === selectedValueMonth && coursesByTitle.indexOf(course) <= -1) {
                                coursesByTitle.push(course);
                            }
                        } else {
                            if (coursesByTitle.indexOf(course) <= -1) {
                                coursesByTitle.push(course);
                            }
                        }
                    }
                });
            });

            courses = coursesByTitle;
        } else {
            return courses;
        }

        return courses;
    }
    public filterByCity(courses) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        const selectedValue = sessionStorage.getItem(`cityTypeFiltering${_site}`);
        this.city = selectedValue;

        const selectedValueYear = sessionStorage.getItem(`yearTypeFiltering${_site}`);
        const selectedValueMonth = sessionStorage.getItem(`monthFiltering${_site}`);

        const coursesByTitle = [];

        if (
            selectedValue !== null &&
            selectedValue !== '0' &&
            !(selectedValue === '') &&
            selectedValue !== this.label &&
            selectedValue !== 'undefined'
        ) {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    if (event.location.city.toString() === selectedValue) {
                        const newDate = new Date(event.beginDateTime);
                        const year = newDate.getFullYear();
                        const month = Number(newDate.getMonth()) + 1;
                        if (
                            selectedValueMonth !== null &&
                            selectedValueMonth !== '0' &&
                            !(selectedValueMonth === '') &&
                            selectedValueMonth !== 'undefined' &&
                            selectedValueMonth !== this.label
                        ) {
                            if (month.toString() === selectedValueMonth) {
                                if (
                                    selectedValueYear !== null &&
                                    selectedValueYear !== '0' &&
                                    !(selectedValueYear === '') &&
                                    selectedValueYear !== 'undefined' &&
                                    selectedValueYear !== this.label
                                ) {
                                    if (year.toString() === selectedValueYear && coursesByTitle.indexOf(course) <= -1) {
                                        coursesByTitle.push(course);
                                    }
                                } else {
                                    if (coursesByTitle.indexOf(course) <= -1) {
                                        coursesByTitle.push(course);
                                    }
                                }
                            }
                        } else {
                            if (
                                selectedValueYear !== null &&
                                selectedValueYear !== '0' &&
                                !(selectedValueYear === '') &&
                                selectedValueYear !== 'undefined' &&
                                selectedValueYear !== this.label
                            ) {
                            } else {
                                if (year.toString() === selectedValueYear && coursesByTitle.indexOf(course) <= -1) {
                                    coursesByTitle.push(course);
                                }
                            }
                        }

                        if (coursesByTitle.indexOf(course) <= -1) {
                            coursesByTitle.push(course);
                        }
                    }
                });
            });
            courses = coursesByTitle;
        }
        return courses;
    }
    public filterByMonth(courses) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();
        const selectedValue = sessionStorage.getItem(`monthFiltering${_site}`);
        this.month = Number(selectedValue);
        const coursesFiltered = [];

        if (selectedValue !== null && selectedValue !== '0' && !(selectedValue === '') && selectedValue !== 'undefined') {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    const newDate = new Date(event.beginDateTime);
                    const month = Number(newDate.getMonth()) + 1;
                    if (month.toString() === selectedValue && !coursesFiltered.includes(course)) {
                        coursesFiltered.push(course);
                    }
                });
            });

            courses = coursesFiltered;
        }

        return courses;
    }

    public filterByTitle(courses) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        const selectedValue = sessionStorage.getItem(`titleFilteringValue${_site}`);

        const coursesByTitle = [];

        if (selectedValue !== null && !(selectedValue === '') && !(selectedValue === 'null')) {
            courses.filter((course) => {
                if (course.name.toLowerCase().indexOf(selectedValue.toLowerCase()) > -1) {
                    coursesByTitle.push(course);
                }
            });

            courses = coursesByTitle;
        }

        this.asc.setResultList(courses);
        return courses;
    }

    public onSelectFilter(selectedValue, localStorageName) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();
        if (selectedValue) {
            sessionStorage.setItem(`${localStorageName}${_site}`, selectedValue.value);
        }

        this.filterCourses();
    }

    public onSelectFilterByProductType(selectedValue) {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        sessionStorage.setItem(`courseTypeIsPresence${_site}`, this.isPresence.toString());
        sessionStorage.setItem(`courseTypeIsOnline${_site}`, this.isOnline.toString());

        this.filterCourses();
    }

    public hasValue(fieldname) {
        return fieldname ? fieldname.toString() !== '' : false;
    }

    public titleChange(valueTyped) {
        this.filterCourses();
    }

    public toggleFilters(element) {
        element.classList.toggle('active');

        this.show = !this.show;
        if (this.show) {
            if (element.parentElement.nextSibling && element.parentElement.nextSibling.style) {
                element.parentElement.nextSibling.style.maxHeight = element.parentElement.nextSibling.scrollHeight + 'px';
            }
        } else {
            if (element.parentElement.nextSibling && element.parentElement.nextSibling.style) {
                element.parentElement.nextSibling.style.maxHeight = null;
            }
        }
    }

    public removeParam(parameter) {
        let url = document.location.href;
        const urlparts = url.split('?');

        if (urlparts.length >= 2) {
            const urlBase = urlparts.shift();
            const queryString = urlparts.join('?');

            const prefix = encodeURIComponent(parameter) + '=';
            const pars = queryString.split(/[&;]/g);
            for (let i = pars.length; i-- > 0; ) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            url = urlBase + '?' + pars.join('&');
            window.history.pushState('', document.title, url); // added this line to push the new url directly to url bar .
            window.history.pushState('', document.title, urlBase);
        }
        return url;
    }

    public resetFilters() {
        const isPortal = this._configurationService.isPartnerPage();

        const _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        sessionStorage.setItem(`titleFilteringValue${_site}`, '');
        sessionStorage.setItem(`monthFiltering${_site}`, '0');
        sessionStorage.setItem(`cityTypeFiltering${_site}`, this.label);
        sessionStorage.setItem(`yearTypeFiltering${_site}`, '0');

        sessionStorage.removeItem(`courseTypeIsOnline${_site}`);
        sessionStorage.removeItem(`courseTypeIsPresence${_site}`);

        if (this._$categories.getValue().length > 0) {
            sessionStorage.removeItem(`selectedSubSubCatValue${_site}`);
        }
        sessionStorage.removeItem(`selectedSubCatValue${_site}`);

        this.filters.reset();
        this.title = '';
        this.month = 0;
        this.year = 0;
        this.city = this.label;

        this.filterCourses();
    }
    public checkIfCoursesHaveBusinessField(categories) {
        this._$categories.next(categories);
        if (this.courses.length > 0) {
            const categoryIDsOfCourses = this.courses.map((course) => {
                return course.categoryId;
            });

            const newCategories = [];
            this._$categories.getValue().forEach((businessfield) => {
                const businessfieldID = businessfield.id;
                if (categoryIDsOfCourses.indexOf(businessfieldID) !== -1 && newCategories.indexOf(businessfield) === -1) {
                    newCategories.push(businessfield);
                }
            });
            this._$categories.next(newCategories);
            if (this._$categories.getValue().length > 1) {
                const businessfield = { id: 0, name: this.label };
                newCategories.unshift(businessfield);
            }
        }
    }
}
